import { Button } from "@/components/ui/button";
import useSurvey from "@/containers/survey/hooks/useSurvey";
import { ArrowDown } from "lucide-react";
import { useFormState } from "react-hook-form";

interface MoveDownButtonProps {
  index: number;
  isLast: boolean;
}

export default function MoveDownButton({ index, isLast }: MoveDownButtonProps) {
  const survey = useSurvey();
  const { isSubmitting, disabled } = useFormState();
  return (
    <Button
      type="button"
      onClick={() => survey.moveQuestion(index, index + 1)}
      disabled={disabled || isLast || isSubmitting}
      variant="ghost"
      size="icon"
      className="hover:bg-slate-200"
      data-testid="move-down"
    >
      <ArrowDown className="w-5 h-5" />
    </Button>
  );
}
